import React from 'react'
import { uniq } from 'lodash'
import Tag from 'discada/dist/Tag'

import CherryGauge from 'components/widgets/CherryGauge'
import { ReactionControl } from 'components/Stats/ReactionStats'

export const FBI_FILTERS = [
  {
    name: 'browserName',
    title: 'Customer Browser',
    type: 'custom',
    fieldName: 'browser',
    defaultValue: 'Unknown',
    extractorFn: browser => {
      return (browser || {}).name
    },
  },
  {
    name: 'browserOs',
    title: 'Customer Operating System',
    type: 'custom',
    fieldName: 'browser',
    defaultValue: 'Unknown',
    extractorFn: browser => {
      return (browser || {}).os
    },
  },
  {
    name: 'appVersion',
    title: 'QuoteTool Version',
    type: 'custom',
    fieldName: 'browser',
    defaultValue: 'Unknown',
    extractorFn: browser => {
      return (browser || {}).appVersion
    },
  },
]

export const LEAD_FILTERS = [
  {
    name: 'new_used',
    title: 'New / Used',
    fieldName: 'condition',
    type: 'valueInSet',
  },
  {
    name: 'year',
    title: 'Vehicle Year',
    type: 'valueInSet',
  },
  {
    name: 'make',
    title: 'Vehicle Make',
    type: 'valueInSet',
  },
  {
    name: 'model',
    title: 'Vehicle Model',
    type: 'valueInSet',
  },
  {
    name: 'zipCode',
    title: 'Customer Zip Code',
    defaultValue: 'Unknown',
  },
  {
    name: 'areaCode',
    title: 'Customer Area Code',
    type: 'custom',
    fieldName: 'phone',
    defaultValue: 'Unknown',
    extractorFn: phone => {
      return (`${phone}`.match(/^[0-9]{3}/) || [])[0]
    },
  },
  {
    name: 'campaigns',
    title: 'Campaigns',
    type: 'valueInSet',
  },
  {
    name: 'referrers',
    title: 'Referrers',
    type: 'valueInSet',
  },
  {
    name: 'sources',
    title: 'Sources',
    type: 'valueInSet',
  },
]

export const LEAD_STATS = [
  { name: 'illuminationsCount' },
  {
    name: 'vehiclesCount',
    extractorFn: lead => (lead.vehicleIds || []).length,
  },
  { name: 'quotesCount', extractorFn: lead => (lead.quoteIds || []).length },
]

export const generateLeadSwitches = (
  timerange = 'during this period',
  rooftopZip,
) => {
  return [
    {
      name: 'recentlySeen',
      title: 'Recently Seen',
      extractorFn: ({ lastSeen }) =>
        lastSeen > Math.floor(Date.now()) - 1000 * 24 * 60 * 60,
    },
    {
      name: 'becameKnown',
      title: `First Seen ${timerange}`,
      extractorFn: ({ becameKnown }) => becameKnown,
    },
    {
      name: 'hasCameBack',
      title: `🙌 Came back ${timerange}`,
      extractorFn: ({ hasCameBack }) => hasCameBack,
    },
    {
      name: 'localCustomer',
      title: 'Only Local Customers',
      extractorFn: ({ zipCode }) => zipCode === rooftopZip,
    },
  ]
}

export const CHERRY_PICK_BUTTONS = [
  {
    name: 'one_cherry',
    render: ({ count }) => (
      <CherryGauge level={1}>
        <Tag color="primary">{count}</Tag>
      </CherryGauge>
    ),
    extractorFn: ({ engagementScore }) => engagementScore === 1,
  },
  {
    name: 'two_cherries',
    render: ({ count }) => (
      <CherryGauge level={2}>
        <Tag color="primary">{count}</Tag>
      </CherryGauge>
    ),

    extractorFn: ({ engagementScore }) => engagementScore === 2,
  },
  {
    name: 'three_cherries',
    render: ({ count }) => (
      <CherryGauge level={3}>
        <Tag color="primary">{count}</Tag>
      </CherryGauge>
    ),
    extractorFn: ({ engagementScore }) => engagementScore === 3,
  },

  {
    name: 'four_cherries',
    render: ({ count }) => (
      <CherryGauge level={4}>
        <Tag color="primary">{count}</Tag>
      </CherryGauge>
    ),
    extractorFn: ({ engagementScore }) => engagementScore === 4,
  },
]

export const generateReactionToggles = reactions => {
  return [
    ...uniq(reactions)
      .filter(r => {
        return r !== 'contact'
      })
      .map(r => {
        return {
          name: r,
          render: ({ count }) => <ReactionControl reaction={r} count={count} />,
          extractorFn: ({ intent = [] }) => intent.includes(r),
        }
      }),
  ]
}

const alphaSortByKey = key => (a, b) => {
  return a[key].localeCompare(b[key])
}

const genericSortByKey = key => (a, b) => {
  if (a[key] > b[key]) {
    return -1
  } else if (a[key] < b[key]) {
    return 1
  } else {
    return 0
  }
}

export const SORT_OPTIONS = {
  cherry: {
    label: 'Cherry Pick',
    sortfn: genericSortByKey('engagementScore'),
  },
  activitiy: {
    label: 'Most Activity',
    sortfn: genericSortByKey('illuminationsCount'),
  },
  recentlyActive: {
    label: 'Most Recent',
    sortfn: genericSortByKey('lastSeen'),
  },
  lastName: {
    label: 'Alphabetically by last name',
    sortfn: alphaSortByKey('lastName'),
  },
}

export const leadSearch = (record, safePatternString) => {
  const {
    firstName = '',
    lastName = '',
    email = '',
    zipCode = '',
    make = [],
    model = [],
    year = [],
  } = record

  const frags = [
    firstName,
    lastName,
    email,
    zipCode,
    ...model.map(x => `model:${x}`),
    ...make.map(x => `make:${x}`),
    ...year.map(x => `year:${x}`),
  ].filter(x => x && x !== '')

  const searchString = frags.join('|')

  let matches = safePatternString.split(' ').map(searchChunk => {
    return Boolean(searchString.match(new RegExp(searchChunk, 'i')))
  })

  return !matches.includes(false)
}
